import React from 'react';

// ÐÐµÐ¹Ð´Ð¶ Ð¶Ð¸Ð²ÑÑ Ð² ÑÑÐµÐ¹ÐºÐµ ÑÐ°Ð±Ð»Ð¸ÑÑ, Ð° Ñ td ÑÑÐ¾Ð¸Ñ word-break: break-word â Ð±ÐµÐ· Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð¹
// ÑÐ¸ÑÐ¸Ð½Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ° ÑÑÐ»Ð¾Ð¿ÑÐ²Ð°ÐµÑÑÑ Ð¸ ÑÑÐ°ÑÑÑ ÑÐ²ÑÑÑÑ Ð¿Ð¾ Ð±ÑÐºÐ²Ð°Ð¼ ("ÐÐÐÐ ÐÐ§ÐÐ ÐÐÐ ÐÐÐ ÐÐ ").
const Status = ({ status, color, backgroundColor, minWidth = 96 }) => {
  return (
    <div
      style={{
        backgroundColor: backgroundColor || 'white',
        border: `1px solid ${color}`,
        borderRadius: '2px',
        padding: '3px 8px',
        width: '100%',
        minWidth,
        boxSizing: 'border-box',
      }}
    >
      <p
        style={{
          textTransform: 'uppercase',
          color: color,
          fontFamily: 'Exo 2',
          fontWeight: 600,
          fontSize: '10px',
          lineHeight: '15px',
          textAlign: 'center',
          wordBreak: 'normal',
        }}
      >
        {status}
      </p>
    </div>
  );
};

export default Status;
